import { ThemeColors } from "@shared/praxis-config";
import { praxisFaviconUrl } from "./load-praxis-config";

const cssVariables: Record<keyof ThemeColors, string> = {
  primary: "--color-primary",
  primaryHover: "--color-primary-hover",
  textPrimary: "--color-text-primary",
  textPrimaryContrast: "--color-text-primary-contrast",
  bgMobileFrom: "--bg-mobile-from",
  bgDesktopFrom: "--bg-desktop-from",
};

export const applyTheme = (theme: ThemeColors, hasFavicon: boolean) => {
  Object.entries(cssVariables).forEach(([key, variable]) => {
    document.documentElement.style.setProperty(
      variable,
      theme[key as keyof ThemeColors],
    );
  });

  if (!hasFavicon) {
    return;
  }
  const favicon =
    document.querySelector<HTMLLinkElement>("link[rel*='icon']") ??
    document.head.appendChild(document.createElement("link"));
  favicon.rel = "icon";
  favicon.href = praxisFaviconUrl();
};

// Must match the animation delay of #app-loader in index.html
const LOADER_DELAY_MS = 500;
const LOADER_MIN_VISIBLE_MS = 400;
const LOADER_FADE_OUT_MS = 250;

const fadeOutLoader = (loader: HTMLElement) => {
  // Fade out from the current opacity, the loader might still be fading in
  loader.style.opacity = getComputedStyle(loader).opacity;
  loader.style.animation = "none";
  void loader.offsetHeight;
  loader.style.transition = `opacity ${LOADER_FADE_OUT_MS}ms ease-in`;
  loader.style.opacity = "0";
  // Timeout instead of transitionend, which does not fire with disabled animations
  setTimeout(() => loader.remove(), LOADER_FADE_OUT_MS);
};

export const showPage = () => {
  document.body.style.visibility = "visible";

  const loader = document.getElementById("app-loader");
  if (!loader) {
    return;
  }

  // performance.now() counts from the page load, like the animation delay of the loader
  const elapsedMs = performance.now();
  if (elapsedMs < LOADER_DELAY_MS) {
    loader.remove();
    return;
  }

  const remainingVisibleMs =
    LOADER_DELAY_MS + LOADER_MIN_VISIBLE_MS - elapsedMs;
  setTimeout(() => fadeOutLoader(loader), Math.max(0, remainingVisibleMs));
};
